//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import {
  PinterestConnectionStatus,
  GetPinterestConnectionStatusResponse,
  OAuthPinterestResponse,
  GetPinterestOAuthUrlResponse,
} from '@bvengineering/pinterest-gateway-service-types';

import { IOAuthPinterestRequest } from '@apis/pinterest-oauth/pinterestOAuthApiModel';
import { makeParams } from '@utils/makeParams';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const PINTEREST_DEFAULT_ENDPOINT = '/api/v1/oauth';

const pinterestGatewayOAuthFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'pinterest_dashboard_gateway',
    `${PINTEREST_DEFAULT_ENDPOINT}${endpoint}`,
    init,
  );
};

/**
 * Gets the Pinterest token connection status
 *
 * GET /api/v1/oauth
 */
export const getConnectionStatus =
  async (): Promise<PinterestConnectionStatus> => {
    const res = await pinterestGatewayOAuthFetch(`/`);

    const json = await res.json<GetPinterestConnectionStatusResponse>();

    return json.data;
  };

/**
 * Gets the Pinterest OAuth url
 *
 * GET /api/v1/oauth/url
 */
export const getOAuthUrl = async (): Promise<string> => {
  const res = await pinterestGatewayOAuthFetch(`/url`);

  const json = await res.json<GetPinterestOAuthUrlResponse>();

  return json.data;
};

/**
 * Connect the client's Pinterest using the provided authCode
 *
 * POST /api/v1/oauth/
 */
export const connect = async (
  request: IOAuthPinterestRequest,
): Promise<PinterestConnectionStatus> => {
  const queryParams = makeParams(request);
  const res = await pinterestGatewayOAuthFetch(`/?${queryParams}`, {
    method: 'POST',
  });

  const json = await res.json<OAuthPinterestResponse>();

  return json.data;
};

/**
 * Revoke the client's Pinterest token
 *
 * DELETE /api/v1/oauth/
 */
export const revokeToken = async (): Promise<void> => {
  await pinterestGatewayOAuthFetch(`/`, { method: 'DELETE' });
};
